import { ContentFilters, ContentTopBar } from 'components';
import { NotificationCustomerFilterForm } from 'features/notification/components/notification-main-filter/notification-customer-filter-form';
import { SAVENotificationCustomerFilterFormValues } from 'features/notification/components/type';
import { useState } from 'react';
import { CompanyType } from 'types';
type VendingTopBarProps = {
  getInitialFilterValues: SAVENotificationCustomerFilterFormValues;
  handleFilter: (values: SAVENotificationCustomerFilterFormValues) => void;
};
export const NotificationTopBarCustomer = ({
  getInitialFilterValues,
  handleFilter 
}: VendingTopBarProps) => {
  useState<CompanyType>();
  const formId = 'notification-customer-filters-form';
  
return (
    <>
      <ContentTopBar
        title={'Customers List'}
      />
      <ContentFilters formId={formId}>
        <NotificationCustomerFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={getInitialFilterValues}
        />
      </ContentFilters>
    </>
  );
};
